import React from 'react';

const GlobalsContext = React.createContext({});
export const { Provider, Consumer } = GlobalsContext;
